<template>
  <div class="card shadow h-100 py-2" :class="'border-left-'+classe">
    <div class="card-body">
      <div class="row no-gutters align-items-center">
        <div class="col mr-2">
          <div class="text-xs font-weight-bold text-uppercase mb-1" :class="'text-'+classe">{{ title }}
          </div>
          <div class="row no-gutters align-items-center">
            <div class="col-auto">
              <div class="h5 mb-0 mr-3 font-weight-bold text-gray-800">{{ value }}  </div>
              <small>{{ prefix }}</small>
            </div>
           <div class="col" v-if="progressBar">
              <div class="progress progress-sm mr-2">
                <div class="progress-bar" :class="'bg-'+classe" role="progressbar"
                     style="width: 50%" aria-valuenow="50" aria-valuemin="0"
                     aria-valuemax="100"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-auto">
          <i class="fa fa-2x text-gray-300" :class="icon"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardStat',
  props:{
    progressBar: Boolean,
    classe: String,
    prefix:String,
    border: String,
    title: String,
    value: {},
    icon: String
  }
}
</script>

<style scoped>

</style>
